'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

/**
 * Authentication service facade.
 * Delegates to either Auth0 or Keycloak provider based on environment configuration.
 *
 * Shared across QuartzX legacy projects. Keep in sync with QuartzX.Web.IAM.Legacy.
 *
 * @module services.auth
 */
angular.module('services.auth', [
  'services.auth0Provider',
  'services.keycloakProvider',
  'services.keycloakInterceptor'
])

.factory('authService', ['auth0Provider', 'keycloakProvider', function(auth0Provider, keycloakProvider) {
  var service = {};

  var authProvider = environment.authProvider || 'auth0';
  var provider = authProvider === 'keycloak' ? keycloakProvider : auth0Provider;

  service.init = function(options) {
    return provider.init(options);
  };

  service.isAuthenticated = function() {
    return provider.isAuthenticated();
  };

  service.user = function() {
    return provider.user();
  };

  service.getIdToken = function() {
    return provider.getAccessToken();
  };

  service.getAccessToken = function() {
    return provider.getAccessToken();
  };

  service.login = function(appStateTarget) {
    return provider.login(appStateTarget);
  };

  service.logout = function() {
    return provider.logout();
  };

  service.handleAuthentication = function() {
    return provider.handleAuthentication();
  };

  // Legacy API stubs for backward compatibility

  service.getProfile = function(cb) {
    provider.user()
      .then(function(profile) {
        cb(null, profile);
      })
      .catch(function(error) {
        cb(error, null);
      });
  };

  service.getCachedProfile = function() {
    console.warn('[authService] getCachedProfile() is deprecated. Use user() instead.');
    return null;
  };

  service.renewTokens = function() {
    // No-op - both providers handle token refresh automatically
  };

  service.scheduleRenewal = function() {
    // No-op - both providers handle token refresh automatically
  };

  return service;
}]);
